import { useState } from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';

export function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  function openCookieSettings() {
    const mgr = (
      window as unknown as {
        consentManager?: { openModal?: () => void };
      }
    ).consentManager;
    if (mgr && typeof mgr.openModal === 'function') {
      mgr.openModal();
    }
  }

  function closeMenu() {
    setMenuOpen(false);
  }

  return (
    <div className="site-shell">
      <header className="site-header">
        <div className="container nav-wrap">
          <Link to="/" className="brand" onClick={closeMenu}>
            <img src="/img/logo-white2.svg" alt="ExpanseFT" />
          </Link>
          <button
            type="button"
            className="menu-toggle"
            aria-expanded={menuOpen}
            aria-controls="primary-nav"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span />
            <span />
            <span />
            <span className="menu-toggle-label">Menu</span>
          </button>
          <div className="nav-actions">
            <div className={`nav-shell${menuOpen ? ' open' : ''}`}>
              <nav className="site-nav" id="primary-nav" aria-label="Primary">
                <NavLink to="/" end onClick={closeMenu}>
                  Home
                </NavLink>
                <NavLink to="/about" onClick={closeMenu}>
                  About
                </NavLink>
                <NavLink to="/news" onClick={closeMenu}>
                  News
                </NavLink>
                <NavLink to="/contact" onClick={closeMenu}>
                  Contact
                </NavLink>
              </nav>
              <Link to="/contact" className="nav-cta" onClick={closeMenu}>
                Let's Talk
              </Link>
            </div>
          </div>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="site-footer">
        <div className="container footer-grid">
          <div className="footer-copy">
            <h3>Let's Talk</h3>
            <p>
              We are always open to discuss your project and shape a solution that works for you and your
              customers.
            </p>
            <p className="footer-trust">Trusted by banks, fintechs, and modern payment innovators.</p>
            <div className="footer-cta-row">
              <Link className="btn btn-secondary" to="/contact">
                Talk to Sales
              </Link>
              <a className="btn btn-outline-light" href="mailto:contactus@expanseft.com?subject=Book%20a%20Demo">
                Book Demo
              </a>
            </div>
          </div>
          <div className="footer-contact">
            <div className="footer-contact-item">
              <h4>Email</h4>
              <p>
                <a href="mailto:contactus@expanseft.com">contactus@expanseft.com</a>
              </p>
            </div>
            <div className="footer-contact-item">
              <h4>Call</h4>
              <p>
                <a href="tel:+15166532500">(516) 653 2500</a>
              </p>
            </div>
          </div>
        </div>
        <div className="container footer-meta">
          <span>© {new Date().getFullYear()} Expanse Financial Technologies, Inc.</span>
          <span>Built for modern fintech programs.</span>
        </div>
        <div className="container footer-legal">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/do-not-sell">Do Not Sell My Personal Information</Link>
          <button type="button" className="footer-link-button" onClick={openCookieSettings}>
            Cookie Settings
          </button>
          <a
            href="https://www.paycomonline.net/v4/ats/web.php/portal/B8FB8F0184497530918CAA2B0EE33619/career-page"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link-external"
          >
            Careers
            <span aria-hidden="true" className="footer-link-external-icon">
              ↗
            </span>
            <span className="visually-hidden"> (opens in a new tab)</span>
          </a>
        </div>
      </footer>
    </div>
  );
}


